import store from '@/store/index.js'

export default {
    store,
    install(Vue, options){
        let createTs = new Date().toISOString();
        store.state.authModule.create_timestamp = createTs;
        Vue.prototype.$store = store;
        Vue.prototype.$storeCreate = createTs;

    }
}